/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ShipmentSize = {
    Pallets12: 'PALLETS_1_2',
    Pallets34: 'PALLETS_3_4',
    LooseOrBoxed: 'LOOSE_OR_BOXED',
    Mixed: 'MIXED'
} as const;
export type ShipmentSize = typeof ShipmentSize[keyof typeof ShipmentSize];

